import React, { useEffect, useRef, useState } from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { Link, useNavigate, NavLink } from "react-router-dom";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import "./Login.scss";
import { Backdrop, useMediaQuery, useTheme } from "@mui/material";
import lightlogo from "../../Img/reglogo.png";
import loginprofilepic from "../../Img/login-icon.svg";
// import lgleft from '../../Img/lgleft.png';
import signin from "../../Img/ph-img-signin.svg";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import FormControl from "@mui/material/FormControl";
// import TextField from '@mui/material/TextField';
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";
// import Button from '@mui/material/Button';
// import Typography from '@mui/material/Typography';
import Modal from "@mui/material/Modal";
import usercalls from "../../Axios";
import consts from "../../constant";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoginBtn from "./LoginBtn";
import AuthHeader from "./AuthHeader";
import AuthLeft from "./AuthLeft";
import Loader from "../Loader";
import { encryptData } from "../../middleware";

import ReCAPTCHA from "react-google-recaptcha";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "transparent",
  // border: '2px solid #000',
  boxShadow: 0,
  borderRadius: "0px",
  outline: "none",
  "@media(max-width:767.98px)": {
    width: "75%",
  },
  p: 0,
};

export default function Login() {
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up("md"));
  const lg = useMediaQuery(theme.breakpoints.up("lg"));
  const path = usercalls();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState();
  const [confirmPassword, setConfirmPassword] = useState();
  const [load, setLoad] = useState(false);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [otpModel, setOtpModel] = useState(false);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const fullOtp = otp.join("");

  const passwordRegex = /^(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.*[0-9]).{8,}$/;
  const regex = /[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,8}(.[a-z{2,8}])?/g;

  // console.log(md, 'md');

  const recaptchaRef = useRef(null); // 👈 create a ref

  const navigate = useNavigate();

  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);

  const handleClickConfirmShowPassword = () =>
    setShowConfirmPassword((show) => !show);

  const [confPassErr, setConfPassErr] = useState("");

  const [token, setToken] = useState(null);

  const handleCaptcha = (value) => {
    console.log("Captcha value:", value);
    setToken(value);
  };

  const inputsRef = useRef([]);

  const handleOtp = (e, index) => {
    const value = e.target.value;

    if (!/^\d?$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < inputsRef.current.length - 1) {
      inputsRef.current[index + 1].focus();
    }
  };
  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !e.target.value && index > 0) {
      inputsRef.current[index - 1].focus();
    }
  };

  const clearOtp = () => {
    const emptyOtp = Array(otp.length).fill("");
    setOtp(emptyOtp);

    // Optional: focus first input again
    inputsRef.current[0]?.focus();
  };
  const handlePaste = (e) => {
    e.preventDefault();

    const pastedData = e.clipboardData.getData("text").replace(/\D/g, ""); // only digits
    const digits = pastedData.slice(0, otp.length).split("");

    const newOtp = [...otp];
    digits.forEach((digit, i) => {
      newOtp[i] = digit;
      inputsRef.current[i].value = digit; // optional: force set for quick visual sync
    });

    setOtp(newOtp);

    // Focus the next empty input (or last one)
    const nextIndex =
      digits.length < otp.length ? digits.length : otp.length - 1;
    inputsRef.current[nextIndex]?.focus();
  };

  const checkconfirmpass = (e) => {
    if (password != e) {
      setConfPassErr("Password Mismatching");
    } else {
      setConfPassErr("");
    }
  };

  const handleSubmit = async () => {
    try {
      // setLoad(true);
      if (email == "") {
        toast.error("Invalid Email Format");

      } else if (password == "") {
        toast.error(
          "Password Must Contain MIN 8 Character , One ALPHABET And Must Contain One Number and Special Characters  Eg : Abc@1234"
        );
      } else if (!token) {
        toast.error("Please Verify Captcha");
      }
      // else if (email && password && confirmPassword == undefined) {
      //   toast.error("Please Enter Password");
      // }
      //  else if (confirmPassword !== password) {
      //   setConfPassErr("Password Mismatching");
      // }
      else {
        setLoad(true);
        var captchauel = `${consts.BackendUrl}/verifyRecaptcha`;
        const captchaVerify = await path.postCallWithoutAuthToken({
          url: captchauel,
          payload: {
            response: token,
          },
        })
        const captchaVerifyResult = await captchaVerify.json();
        console.log("🚀 ~ handleSubmit ~ captchaVerifyResult:", captchaVerifyResult)
        if (!captchaVerifyResult?.success) {
          setLoad(false);
          return toast.error(captchaVerifyResult?.message)
        }


        const url = `${consts.BackendUrl}/login`;
        const payload = {
          email: email,
          password: password,
        };
        const response = await path.postCallWithoutAuthToken({ url, payload });
        const result = await response.json();
        // console.log(result, 'result');
        if (result?.success) {
          setLoad(false);

          if (result?.result?.token != null) {
            // localStorage.setItem("email", result?.result?.user?.email);
            // console.log(result?.result?.user,"userdwetails");
            localStorage.setItem("use", result?.result?.user?._id);
            window.localStorage.setItem(
              "user",
              encryptData(JSON.stringify(result?.result?.user))
            );
            window.localStorage.setItem("Rikosta", result?.result?.token);
            // console.log(result?.result, "Result login");

            window.localStorage.setItem(
              "user",
              encryptData(JSON.stringify(result?.result?.user))
            );
            window.localStorage.setItem("Rikosta", result?.result?.token);

            navigate(`/trade/${consts?.MainPair}?type=spot`);
            setLoad(false);
          } else {
            setOtpModel(true);
            setLoad(false);
          }
        } else {
          setLoad(false);
          toast.error(result.message);
        }
      }
      recaptchaRef.current?.reset();
    } catch (error) {
      setLoad(false);
      recaptchaRef.current?.reset();
      // toast.error(error.response.data.message)
      console.log("🚀 ~ register ~ error:", error);
    }
  };

  useEffect(() => {
    // console.log(
    //   window.localStorage.getItem("email"),
    //   "window.localStorage.getItem('email')"
    // );
    if (window.localStorage.getItem("email")) {
      setEmail(localStorage.getItem("email"));
      localStorage.removeItem("email");
    }
  }, []);

  const VerifyOtp = async () => {
    try {
      setLoad(true);
      const url = `${consts.BackendUrl}/verify2faotp`;
      const payload = {
        email: email,
        secret: fullOtp,
      };
      const response = await path.postCallWithoutAuthToken({ url, payload });
      const result = await response.json();

      if (result?.success === true) {
        setOtpModel(false);
        setLoad(false);
        // localStorage.setItem("email", result?.result?.user?.email);
        // console.log(result?.result?.user,"userdwetails");
        localStorage.setItem("use", result?.result?.user?._id);
        window.localStorage.setItem(
          "user",
          encryptData(JSON.stringify(result?.result?.user))
        );
        window.localStorage.setItem("Rikosta", result?.result?.token);
        // console.log(result?.result, "Result login");

        window.localStorage.setItem(
          "user",
          encryptData(JSON.stringify(result?.result?.user))
        );
        window.localStorage.setItem("Rikosta", result?.result?.token);

        navigate(`/trade/${consts?.MainPair}?type=spot`);
      } else {
        setLoad(false);
        toast.error(result.message);
        fullOtp = "";
      }
    } catch (error) {
      console.log(error, "error");
      toast.error(error?.response?.data?.message);
      console.log(error);
      clearOtp();
      setLoad(false);

      // fullOtp = "";
    }
  };

  useEffect(() => {
    if (otp.every((digit) => digit !== "")) {
      const fullOtp = otp.join("");
      VerifyOtp();
      // console.log("OTP complete:", fullOtp);
      // Optionally call verification API here
    }
  }, [otp]);

  return (
    <>
      {/* <AuthHeader /> */}

      <ToastContainer />
      <div className="register">
        {load && (
          <div className="main-loader">
            <Loader />
          </div>
        )}
        <Grid
          container
          component="main"
          spacing={2}
          sx={{ alignItems: "center", pt: 0, height: !lg && "100vh" }}
          className={!md ? "medium" : ""}
        >
          {lg && (
            <Grid item xs={12} sm={12} md={6} lg={5.5} sx={{ pl: "13px" }}>
              <AuthLeft
                onClick={() => {
                  navigate("/");
                }}
                className="cursor"
              />
            </Grid>
          )}
          <Grid item xs={12} sm={12} md={12} lg={6}>
            <Grid
              container
              sx={{ justifyContent: "center", alignItems: "center" }}
            >
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Box
                  sx={{
                    my: md && 3,
                    mx: md && 8,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    maxWidth: "700px",
                    margin: "0 auto",
                    padding: "10px",
                  }}
                // className={!md && "log-bcg"}
                >
                  <Typography component="h1" variant="h4" className="c-accout">
                    Sign In to Dreamster-Exchange
                  </Typography>
                  <LoginBtn />

                  <Box
                    // component="form"
                    // noValidate
                    // onSubmit={handleSubmit}
                    sx={{ mt: 1, width: "100%" }}
                  >
                    {/* <div className="profile-lock">
                      <div className="company-profile">
                        <img src={loginprofilepic} alt="loginprofilepic" />
                      </div>
                      <div className="company-address">
                        <Typography
                          variant="body2"
                          sx={{ color: "var(--mdl2-gray)" }}
                        >
                          Check if your URL is correct
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{ fontSize: "14px", color: "var(--clr-font)", display: "flex", alignItems: "center", gap: "6px", marginTop: "4px" }}
                        >
                          <span>
                            <svg
                              width="16"
                              height="20"
                              viewBox="0 0 16 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M13 7V5C13 2.2 10.8 0 8 0C5.2 0 3 2.2 3 5V7C1.3 7 0 8.3 0 10V17C0 18.7 1.3 20 3 20H13C14.7 20 16 18.7 16 17V10C16 8.3 14.7 7 13 7ZM5 5C5 3.3 6.3 2 8 2C9.7 2 11 3.3 11 5V7H5V5ZM9.1 13.5L9 13.6V15C9 15.6 8.6 16 8 16C7.4 16 7 15.6 7 15V13.6C6.4 13 6.3 12.1 6.9 11.5C7.5 10.9 8.4 10.8 9 11.4C9.6 11.9 9.7 12.9 9.1 13.5Z"
                                fill="#1A8F5C"
                              />
                            </svg>
                          </span>
                          https://www.Dreamster-Exex.com
                        </Typography>
                      </div>
                    </div> */}

                    <div className="email-fill mt-30">
                      <div className="email-name" style={{ marginTop: "8px" }}>
                        Email<span className="required"> * </span>
                      </div>
                      <TextField
                        className="inputtext-box"
                        margin="normal"
                        required
                        fullWidth
                        id="email"
                        placeholder="Enter your email address"
                        name="email"
                        autoComplete="email"
                        autoFocus
                        value={email}
                        onChange={(e) => {
                          setEmail(e.target.value);
                        }}
                      />
                    </div>

                    <div className="email-fill " style={{ marginTop: "8px" }}>
                      <div className="email-name">
                        Password<span className="required"> * </span>
                      </div>
                      <FormControl
                        sx={{ mt: 1, width: "100%" }}
                        variant="outlined"
                      >
                        <OutlinedInput
                          id="outlined-adornment-password"
                          type={showPassword ? "text" : "password"}
                          value={password}
                          placeholder="Enter your password"
                          onChange={(e) => {
                            setPassword(e.target.value);
                          }}
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                aria-label={
                                  showPassword
                                    ? "hide the password"
                                    : "display the password"
                                }
                                onClick={handleClickShowPassword}
                                edge="end"
                              >
                                {showPassword ? (
                                  <Visibility className="eye-icon" />
                                ) : (
                                  <VisibilityOff className="eye-icon" />
                                )}
                              </IconButton>
                            </InputAdornment>
                          }
                        // label="Password"
                        />
                      </FormControl>
                    </div>
                    <div className="reg-forget mt-10 display-2">
                      <Link to="/register" variant="body2">
                        Not a member?
                      </Link>
                      <Link to="/forgot" variant="body2">
                        Forgot Password?
                      </Link>
                    </div>
                    <div className="mt-20">
                      <ReCAPTCHA
                        ref={recaptchaRef}
                        sitekey="6LeziG4rAAAAAArwcQNuLxeb3GG-pZug3L3flFIO"
                        onChange={handleCaptcha}
                      />
                    </div>


                    <div className="common-btn">
                      {load ? (
                        <Button fullWidth sx={{ mt: 3, mb: 2 }}>
                          Processing...
                        </Button>
                      ) : (
                        <Button
                          type="submit"
                          fullWidth
                          sx={{ mt: 3, mb: 2 }}
                          // onClick={() => {
                          //   navigate("/trade");
                          // }}
                          onClick={() => {
                            handleSubmit();
                          }}
                        >
                          Login now
                        </Button>
                      )}
                    </div>

                    {/* <div className="text-center accnt-sign mt-10">
                      <Link to="/register" variant="body2">
                        Don't have an account? <span>Sign Up</span>
                      </Link>
                    </div>

                    <div className="text-center accnt-sign mt-10">
                      <Link to="/resend" variant="body2">
                        Resend Verification Email? <span>Resend</span>
                      </Link>
                    </div> */}
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Grid>
          <Modal
            open={open}
            // onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <div className="text-right">
                <HighlightOffIcon onClick={handleClose} />
              </div>
              <div className="c-accout text-center">
                Registered Successfully
              </div>
              <div className="alraedy mt-20">
                Thankyou for registering with us.
              </div>
              <div className="alraedy mt-10">Kindly Verify your email</div>

              <div className="regbtn mt-10">
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{ mt: 3, mb: 2 }}
                  onClick={() => {
                    navigate("/verify");
                  }}
                >
                  Verify
                </Button>
              </div>
            </Box>
          </Modal>
          <Backdrop
            sx={(theme) => ({
              color: "#fff",
              zIndex: theme.zIndex.drawer + 1,
              backdropFilter: "blur(2px)",
            })}
            open={otpModel}
          // onClick={handleClose}
          ></Backdrop>
          <Modal
            open={otpModel}
            // onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <form class="otp-Form">
                <span class="mainHeading">Enter OTP</span>
                <p class="otpSubheading">
                  We have sent a verification code to your mobile number
                </p>
                <div className="inputContainer">
                  {[0, 1, 2, 3, 4, 5].map((_, index) => (
                    <input
                      key={index}
                      type="text"
                      maxLength={1}
                      className="otp-input"
                      value={otp[index]}
                      required
                      onPaste={index === 0 ? handlePaste : undefined}
                      ref={(el) => (inputsRef.current[index] = el)}
                      onChange={(e) => {
                        handleOtp(e, index);
                      }}
                      onKeyDown={(e) => handleKeyDown(e, index)}
                    />
                  ))}
                </div>
                <button class="verifyButton" type="submit">
                  Verify
                </button>
                <button
                  class="exitBtn"
                  onClick={() => {
                    setOtpModel(false);
                  }}
                >
                  ×
                </button>
              </form>
            </Box>
          </Modal>
        </Grid>
      </div>
    </>
  );
}
